import { useEffect, useLayoutEffect, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import gsap from 'gsap'
import './about.css'

import Nav from '../Nav/Nav'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'

const About = ({sidebarIsOpen, setSidebarIsOpen}) =>
{
    const overlayRef = useRef()
    const titleRef = useRef()
    const subRef = useRef()
    
    // Close sidebar
    useEffect(()=>{
        setSidebarIsOpen(false)
    },[])

    useLayoutEffect(()=>{
        window.scrollTo({
            top:0,
            left:0,
            behavior:'smooth'
        })
    },[])

    useEffect(()=>{
        gsap.to(overlayRef.current, {duration:1, scaleX:0, transformOrigin: 'right', ease: "expo.in"})
        gsap.fromTo(titleRef.current, {y: 500}, {delay:1, duration:0.3, y:0, ease: "expo.out"})
        gsap.fromTo(subRef.current, {y: 500}, {delay:1.2, duration:0.3, y:0, ease: "expo.out"})
    },[])

    return(
        <div className="about">
            <Helmet>
                <title>Antino Kila - About me</title>
                <meta name='description' content='This is Antino Kila, a creative frontend developer based in United Kingdom.' />
            </Helmet>

            <div className="about-overlay" ref={overlayRef}></div>

            <Nav sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} />
            {sidebarIsOpen? <Sidebar /> : ""}

            <h1 ref={titleRef}>About me</h1>

            <p className='about-first' ref={subRef}>A <span>creative developer</span> based in United Kingdom. I graduaded from the <span>
            Technological Educational Institute of Create </span>, with a BSc in IT Enginnering. I had the oppurtunity to work with
            a variety of programming languages suchs as C++ and Java as well as gain an all round knowledge
            about IT.</p>

            <p className='about-second'>Currently I focus on modern web development and 3D graphics. I'm involved in projects as 
            a Full Stack developer building complete web applications, as a FrontEnd developer responsible for the visual part and design.
            I work on 3d projects or I design, build and deploy websites on demand.</p>

            <div className="about-skills">
                <div>HTML / CSS</div>
                <div>JavaScript</div>
                <div>React</div>
                <div>React-Three</div>
                <div>Three.js</div>
                <div>GLSL</div>
                <div>WebGL</div>
                <div>Node</div>
                <div>Express</div>
                <div>MongoDB</div>
                <div>Blender</div>
                <div>Cannon.js</div>
            </div>

            <Footer />
        </div>
    )
}

export default About